export default __webpack_public_path__ + "static/modal-do-dark-5c884f6c3c98948fe6ad9fc9dc8220493323e6a67d29fee9a3c9d9c9ec54797e.png";